import * as React from 'react';

// import Anchor from './Anchor';

const Footer = React.memo(() => (
  <>
    {/* <footer className="bg-white border-t border-gray-400 shadow">
        <div className="container flex max-w-4xl py-8 mx-auto">
          <div className="flex flex-wrap w-full mx-auto">
            <div className="flex w-full md:w-1/2">
              <div className="px-8">
                <h3 className="font-bold text-gray-900">About</h3>
                <p className="py-4 text-sm text-gray-600">My blog</p>
              </div>
            </div>

            <div className="flex w-full md:w-1/2">
              <div className="px-8">
                <h3 className="font-bold text-gray-900">Social</h3>
                <ul className="items-center pt-3 text-sm list-reset">
                  <li>
                    <Anchor>Add social link</Anchor>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </footer> */}
  </>
));

export default Footer;
